module.exports = __webpack_public_path__ + "img/purple-header-in.08690415.png";